import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import useTimetableBannerNewsQuery from 'components/queries/useTimetableBannerNewsQuery';
import Message from 'pages/LiveTravelInformation/Message';
import { localeToTimetableServiceMarketEnum } from 'utils/locale';

import { StyledDisruptionMessages } from './HomePage.styles';

const CompanyNewsBanner = ({ intl: { locale } }) => {
  const market = localeToTimetableServiceMarketEnum(locale);
  const { timetableBannerNews } = useTimetableBannerNewsQuery({ market });

  if (!timetableBannerNews?.length) {
    return null;
  }

  return (
    <StyledDisruptionMessages data-testid="company-news-banners">
      {timetableBannerNews.map((newsItem) => (
        <Message key={newsItem.id} {...newsItem} alert detailsPath={`/travel-updates/${encodeURIComponent(newsItem.id)}`} />
      ))}
    </StyledDisruptionMessages>
  );
};

CompanyNewsBanner.propTypes = {
  intl: intlShape
};

export default injectIntl(CompanyNewsBanner);
